import React from 'react';
import Label from '../components/label';
import './styles.css';

const LabelField = ({
  titleLabel,
  classNameWrapper,
  valueLabel,
  required,
  enableIcon,
  onClickIcon,
  classNameIcon,
  titleIcon,
  ...others
}) => (
  <>
    <div className={`wrapper-field ${classNameWrapper}`}>
      <Label
        enableIcon={enableIcon}
        onClickIcon={onClickIcon}
        classNameIcon={classNameIcon}
        titleIcon={titleIcon}
      >
        {required ? `${titleLabel}*` : `${titleLabel}`}
      </Label>
      <div className="label-field">
        <Label {...others}> {valueLabel} </Label>
      </div>
    </div>
  </>
);

export default LabelField;
